import { api } from '../../api/endpoints'
import { errorMessage } from '../../api/client'
import type { Notify } from '../../api/types'
import { db, type LocalChannel } from '../../db/db'
import { toast } from '../../state/toasts'

/** Saves how a conversation notifies me: at once on this device, put back if the server refuses. Returns whether it saved. */
export async function saveNotify(channel: Pick<LocalChannel, 'id' | 'notify' | 'mutedUntil'>, notify: Notify, mutedUntil: string | null): Promise<boolean> {
  const previous = { notify: channel.notify, mutedUntil: channel.mutedUntil }
  await db.channels.update(channel.id, { notify, mutedUntil })
  try {
    await api.setNotify(channel.id, notify, mutedUntil)
    return true
  } catch (error) {
    await db.channels.update(channel.id, previous)
    toast(`Couldn't update notifications. ${errorMessage(error)}`, { tone: 'error' })
    return false
  }
}
